export default __webpack_public_path__ + "static/media/success-icon.00f99e6c.svg";